/* eslint-disable */
import {TypedDocumentNode as DocumentNode} from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {[key: string]: unknown}> = {[K in keyof T]: T[K]};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]?: Maybe<T[SubKey]>};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {[SubKey in K]: Maybe<T[SubKey]>};
export type MakeEmpty<T extends {[key: string]: unknown}, K extends keyof T> = {[_ in K]?: never};
export type Incremental<T> = T | {[P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: {input: string; output: string};
    String: {input: string; output: string};
    Boolean: {input: boolean; output: boolean};
    Int: {input: number; output: number};
    Float: {input: number; output: number};
    /**
     * The `Upload` special type represents a file to be uploaded in the same HTTP request as specified by
     *  [graphql-multipart-request-spec](https://github.com/jaydenseric/graphql-multipart-request-spec).
     */
    Upload: {input: any; output: any};
};

/** An offer request made via the occasion or brands/models page */
export type ActionType = {
    __typename?: 'ActionType';
    /** Brand for which the offer request was made incase of brand/models page */
    brand?: Maybe<BrandType>;
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Customer who made the request */
    customer?: Maybe<CustomerType>;
    /** customer_id */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** json encoded string with information of the offer */
    extra?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Model for which the offer request was made incase of brand/models page */
    model?: Maybe<ModelType>;
    /** Occasion on which the offer occured */
    occasion?: Maybe<OccasionType>;
    /** ID of the occasion */
    occasion_id?: Maybe<Scalars['Int']['output']>;
    /** Remarks of the customer */
    remarks?: Maybe<Scalars['String']['output']>;
    /** Type of offer request (occasion or brand/model) */
    type?: Maybe<Scalars['String']['output']>;
};

/** Planner activity */
export type ActivityType = {
    __typename?: 'ActivityType';
    /** Identifier */
    id?: Maybe<Scalars['String']['output']>;
    /** Display name */
    name?: Maybe<Scalars['String']['output']>;
    /** Type of activity (main|sub) */
    type?: Maybe<Scalars['String']['output']>;
};

/** Advise Quality */
export type AdviseQualityType = {
    __typename?: 'AdviseQualityType';
    /** Total score for the advise quality */
    total_score?: Maybe<Scalars['Int']['output']>;
    /** widgets on which the score is based on */
    widgets?: Maybe<Array<Maybe<AdviseQualityWidgetType>>>;
};

/** Advise Quality widget */
export type AdviseQualityWidgetType = {
    __typename?: 'AdviseQualityWidgetType';
    /** Advise score is for */
    adviseName?: Maybe<Scalars['String']['output']>;
    /** If there is a campaign active. NULL means there is no campaign related to it */
    campaignActive?: Maybe<Scalars['Boolean']['output']>;
    /** Score for the advise quality widget */
    score?: Maybe<Scalars['Int']['output']>;
};

/** App configuration */
export type AppconfigType = {
    __typename?: 'AppconfigType';
    /** URL of the app icon */
    appicon?: Maybe<Scalars['String']['output']>;
    /** App bundle id */
    appid?: Maybe<Scalars['String']['output']>;
    /** Application name */
    appname?: Maybe<Scalars['String']['output']>;
    /** Background color for PWA */
    background_color?: Maybe<Scalars['String']['output']>;
    /** Background text color for PWA */
    background_text_color?: Maybe<Scalars['String']['output']>;
    /** Border color for PWA */
    border_color?: Maybe<Scalars['String']['output']>;
    /** Button color for PWA */
    button_color?: Maybe<Scalars['String']['output']>;
    /** Button text color for PWA */
    button_text_color?: Maybe<Scalars['String']['output']>;
    /** App colors */
    color?: Maybe<Scalars['String']['output']>;
    /** Show app icon yes/no */
    display_app_icon?: Maybe<Scalars['Boolean']['output']>;
    /** Facebook ID for the login */
    facebook_id?: Maybe<Scalars['String']['output']>;
    /** Firebase API key */
    firebase_api_key?: Maybe<Scalars['String']['output']>;
    /** Foreground color for PWA */
    foreground_color?: Maybe<Scalars['String']['output']>;
    /** Google analytics 4 code */
    google_analytics_4_code?: Maybe<Scalars['String']['output']>;
    /** Google analytics code */
    google_analytics_code?: Maybe<Scalars['String']['output']>;
    /** Google ID for the login */
    google_id?: Maybe<Scalars['String']['output']>;
    /** Header color for PWA */
    header_color?: Maybe<Scalars['String']['output']>;
    /** Header text color for PWA */
    header_text_color?: Maybe<Scalars['String']['output']>;
    /** Input border color for PWA */
    input_border_color?: Maybe<Scalars['String']['output']>;
    /** Url to login screen image */
    loginscreen?: Maybe<Scalars['String']['output']>;
    /** Menu item 2 */
    menu_2?: Maybe<Scalars['String']['output']>;
    /** Menu item 3 */
    menu_3?: Maybe<Scalars['String']['output']>;
    /** Extra menu items */
    menu_extra?: Maybe<Array<Maybe<MenuItemType>>>;
    /** Url to menu screen image */
    menuscreen?: Maybe<Scalars['String']['output']>;
    /** Show appointment in more */
    more_appointment?: Maybe<Scalars['Boolean']['output']>;
    /** Show contact in more */
    more_contact?: Maybe<Scalars['Boolean']['output']>;
    /** Show damage report in more */
    more_damage_report?: Maybe<Scalars['Boolean']['output']>;
    /** Show occasions in more */
    more_occasions?: Maybe<Scalars['Boolean']['output']>;
    /** Show profile in more */
    more_profile?: Maybe<Scalars['Boolean']['output']>;
    /** Show reviews in more */
    more_reviews?: Maybe<Scalars['Boolean']['output']>;
    /** Menu item 2 */
    pwa_menu_2?: Maybe<Scalars['String']['output']>;
    /** Menu item 3 */
    pwa_menu_3?: Maybe<Scalars['String']['output']>;
    /** Show appointment in more */
    pwa_more_appointment?: Maybe<Scalars['Boolean']['output']>;
    /** Show chat in more */
    pwa_more_chat?: Maybe<Scalars['Boolean']['output']>;
    /** Show contact in more */
    pwa_more_contact?: Maybe<Scalars['Boolean']['output']>;
    /** Show damage report in more */
    pwa_more_damage_report?: Maybe<Scalars['Boolean']['output']>;
    /** Show occasions in more */
    pwa_more_occasions?: Maybe<Scalars['Boolean']['output']>;
    /** Show profile in more */
    pwa_more_profile?: Maybe<Scalars['Boolean']['output']>;
    /** Show reviews in more */
    pwa_more_reviews?: Maybe<Scalars['Boolean']['output']>;
    /** Show Facebook login button yes/no */
    show_facebook_login?: Maybe<Scalars['Boolean']['output']>;
    /** Show Google login button yes/no */
    show_google_login?: Maybe<Scalars['Boolean']['output']>;
    /** Url to first slider image */
    sliderphoto1?: Maybe<Scalars['String']['output']>;
    /** Url to second slider image */
    sliderphoto2?: Maybe<Scalars['String']['output']>;
    /** Url to third slider image */
    sliderphoto3?: Maybe<Scalars['String']['output']>;
    /** Url to splash screen image */
    splashscreen?: Maybe<Scalars['String']['output']>;
    /** App widget */
    widget?: Maybe<Scalars['String']['output']>;
};

/** Planner Appointment request */
export type AppointmentRequestType = {
    __typename?: 'AppointmentRequestType';
    /** Requested activity */
    activity?: Maybe<ActivityType>;
    /** date (Y-m-d H:i) */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Customer who made the request */
    customer?: Maybe<CustomerType>;
    /** date (Y-m-d H:i) */
    date?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['String']['output']>;
    /** Location for which the request is made */
    location?: Maybe<LocationType>;
    /** Mileage of the vehicle */
    mileage?: Maybe<Scalars['Int']['output']>;
    /** Remarks given with the request */
    remarks?: Maybe<Scalars['String']['output']>;
    /** Replacement vehicle requested */
    replacement_vehicle?: Maybe<ReplacementVehicleType>;
    /** Vehicle for which the request is made */
    specialty?: Maybe<SpecialtyType>;
    /** Status of the request (AWAITING_REACTION | ACCEPTED | REJECTED | EDITED) */
    status?: Maybe<Scalars['String']['output']>;
    /** JSON encoded string with sub activities */
    sub_activities?: Maybe<Scalars['String']['output']>;
    /** date (Y-m-d H:i) */
    updated_at?: Maybe<Scalars['String']['output']>;
    updated_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Vehicle for which the request is made */
    vehicle?: Maybe<VehicleType>;
};

/** A customer audit trail item */
export type AuditTrailItemType = {
    __typename?: 'AuditTrailItemType';
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Description of audit trail item */
    description?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Type of audit trail item */
    type?: Maybe<Scalars['String']['output']>;
};

/** The types of availabilities */
export enum AvailabilityEnum {
    Available = 'available',
    Closed = 'closed',
    Partially = 'partially',
    Unavailable = 'unavailable',
}

export type AvailabilityInputType = {
    /** Enum of availability, can be: closed|unavailable|partially|available */
    availability?: InputMaybe<AvailabilityEnum>;
    /** Date the availability applies to, in Y-m-d format */
    date: Scalars['String']['input'];
    specialty_id: Scalars['Int']['input'];
};

/** Planner availability between 2 dates */
export type AvailabilityType = {
    __typename?: 'AvailabilityType';
    /** Enum of availability, can be: closed|unavailable|partially|available */
    availability?: Maybe<Scalars['String']['output']>;
    /** Date the availability applies to, in Y-m-d format */
    date?: Maybe<Scalars['String']['output']>;
};

/** Brand */
export type BrandType = {
    __typename?: 'BrandType';
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Image for brand */
    image_url?: Maybe<Scalars['String']['output']>;
    /** Models */
    models?: Maybe<Array<Maybe<ModelType>>>;
    /** Name of the brand */
    name?: Maybe<Scalars['String']['output']>;
};

/** Break Type */
export type BreakTimeType = {
    __typename?: 'BreakTimeType';
    /** End date/time of break time */
    end?: Maybe<Scalars['String']['output']>;
    /** Start date/time of break time */
    start?: Maybe<Scalars['String']['output']>;
};

/** Settings for Carflow plugins */
export type CarflowSettingsType = {
    __typename?: 'CarflowSettingsType';
    /** Code for the car comparer plugin */
    car_comparer_code?: Maybe<Scalars['String']['output']>;
    /** Code for the car details plugin */
    car_details_code?: Maybe<Scalars['String']['output']>;
    /** Code for the financing plugin */
    financing_code?: Maybe<Scalars['String']['output']>;
    /** Code for the forms plugin */
    forms_code?: Maybe<Scalars['String']['output']>;
    /** Code for the newsletter plugin */
    newsletter_code?: Maybe<Scalars['String']['output']>;
    /** Code for the reservation plugin */
    reservation_code?: Maybe<Scalars['String']['output']>;
    /** Code for the search plugin */
    search_code?: Maybe<Scalars['String']['output']>;
    /** Code for the stock plugin */
    stock_code?: Maybe<Scalars['String']['output']>;
};

/** Chat message */
export type ChatMessageType = {
    __typename?: 'ChatMessageType';
    /** CTA action to be displayed */
    action?: Maybe<Scalars['String']['output']>;
    /** Date the message was created */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** File reference to uploaded attachment */
    file?: Maybe<FileReferenceType>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Message */
    message?: Maybe<Scalars['String']['output']>;
    /** Notification the customer replied to */
    persistedNotification?: Maybe<NotificationType>;
    /** Message has been read by its receiver */
    read?: Maybe<Scalars['Boolean']['output']>;
    /** User who sent the message, null indicates the message was sent by the customer */
    user?: Maybe<UserType>;
};

/** Chat */
export type ChatType = {
    __typename?: 'ChatType';
    /** Customer the chat belongs to */
    customer?: Maybe<CustomerType>;
    /** ID of the customer */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** Name of the customer the chat is with */
    customer_name?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Messages */
    messages?: Maybe<Array<Maybe<ChatMessageType>>>;
    /** Status of the chat */
    status?: Maybe<Scalars['String']['output']>;
    /** UUID used in anonymous chats */
    uuid?: Maybe<Scalars['String']['output']>;
};

/** Chat */
export type ChatTypeMessagesArgs = {
    last_message_id?: InputMaybe<Scalars['Int']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    read?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A detail of a company */
export type CompanyDataType = {
    __typename?: 'CompanyDataType';
    /** Technical reference to field */
    key?: Maybe<Scalars['String']['output']>;
    /** Name of field */
    name?: Maybe<Scalars['String']['output']>;
    /** Actual value of the data field */
    value?: Maybe<Scalars['String']['output']>;
};

/** A company */
export type CompanyType = {
    __typename?: 'CompanyType';
    /** The date and time this customer was created (Y-m-d H:i:s) */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Details of a company */
    data?: Maybe<Array<Maybe<CompanyDataType>>>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** The date and time this customer was last edited (Y-m-d H:i:s) */
    updated_at?: Maybe<Scalars['String']['output']>;
    updated_at_iso8601?: Maybe<Scalars['String']['output']>;
};

/** A contact form submission */
export type ContactFormType = {
    __typename?: 'ContactFormType';
    /** Customer who made the request */
    customer?: Maybe<CustomerType>;
    /** customer_id */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** license plate in the contact form */
    license_plate?: Maybe<Scalars['String']['output']>;
    /** message in the contact form */
    message?: Maybe<Scalars['String']['output']>;
    /** Status of the contact form */
    status?: Maybe<Scalars['String']['output']>;
};

/** Account for logged in customer */
export type CustomerAccountType = {
    __typename?: 'CustomerAccountType';
    /** date customer account was created at */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** customer */
    customer?: Maybe<CustomerType>;
    /** customerDevices */
    customerDevices?: Maybe<Array<Maybe<CustomerDeviceType>>>;
    /** customer_id */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** date the customer last used the app */
    date_last_seen?: Maybe<Scalars['String']['output']>;
    date_last_seen_iso8601?: Maybe<Scalars['String']['output']>;
    /** email address */
    email?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Shows wether or not the customer has completed the onboarding */
    onboarding_completed?: Maybe<Scalars['Boolean']['output']>;
    /** If true the customer must be shown the onboarding process */
    show_onboarding?: Maybe<Scalars['Boolean']['output']>;
    /** token */
    token?: Maybe<Scalars['String']['output']>;
};

/** Customer changelog data item */
export type CustomerChangelogDataType = {
    __typename?: 'CustomerChangelogDataType';
    /** Type of changelog item. */
    field?: Maybe<Scalars['String']['output']>;
    /** New value of field */
    new_value?: Maybe<Scalars['String']['output']>;
    /** Old value of field */
    old_value?: Maybe<Scalars['String']['output']>;
};

/** Customer changelog item */
export type CustomerChangelogType = {
    __typename?: 'CustomerChangelogType';
    /** List of changes per field */
    changes?: Maybe<Array<Maybe<CustomerChangelogDataType>>>;
    /** Customer the change belongs to */
    customer?: Maybe<CustomerType>;
    /** Date of change */
    date?: Maybe<Scalars['String']['output']>;
    /** Additional identifier such as license_plate */
    identifier?: Maybe<Scalars['String']['output']>;
    /** Type of changelog item. */
    type?: Maybe<Scalars['String']['output']>;
};

/** Data for a customer */
export type CustomerDataInputType = {
    /** Key describing which field this data belongs to */
    key: Scalars['String']['input'];
    /** Value of the data */
    value: Scalars['String']['input'];
};

/** A detail of a customer */
export type CustomerDataType = {
    __typename?: 'CustomerDataType';
    /** Technical reference to field */
    key?: Maybe<Scalars['String']['output']>;
    /** Name of field */
    name?: Maybe<Scalars['String']['output']>;
    /** Actual value of the data field */
    value?: Maybe<Scalars['String']['output']>;
};

/** Device (app installation) for a customer */
export type CustomerDeviceType = {
    __typename?: 'CustomerDeviceType';
    /** customer_account_id */
    customer_account_id?: Maybe<Scalars['Int']['output']>;
    /** The registered device type with the token (Android or iOS) */
    device_type?: Maybe<Scalars['String']['output']>;
    /** firebase_token */
    firebase_token?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
};

/** The types of CustomerField classifications */
export enum CustomerFieldClassificationEnum {
    Date = 'DATE',
    Number = 'NUMBER',
    Text = 'TEXT',
}

/** Customer Field */
export type CustomerFieldInputType = {
    /** Field classification (default: TEXT) */
    classification?: InputMaybe<CustomerFieldClassificationEnum>;
    /** Technical reference to field */
    key: Scalars['String']['input'];
    /** Name of field */
    name: Scalars['String']['input'];
};

/** A field definition of a customer data field */
export type CustomerFieldType = {
    __typename?: 'CustomerFieldType';
    /** Field classification */
    classification?: Maybe<Scalars['String']['output']>;
    /** True if is this is a default field. False if this field is created by the user or a third party */
    default?: Maybe<Scalars['Boolean']['output']>;
    /** Allow customer to edit the field */
    edit_public?: Maybe<Scalars['Boolean']['output']>;
    /** Field is_required via pivot */
    is_required?: Maybe<Scalars['Boolean']['output']>;
    /** Technical reference to field */
    key?: Maybe<Scalars['String']['output']>;
    /** Name of field */
    name?: Maybe<Scalars['String']['output']>;
    /** Field rules via pivot */
    rules?: Maybe<Scalars['String']['output']>;
    /** Display field for customer */
    show_public?: Maybe<Scalars['Boolean']['output']>;
};

/** A customer */
export type CustomerInputType = {
    /** Details of a customer */
    data?: InputMaybe<Array<InputMaybe<CustomerDataInputType>>>;
    /** Id of the user */
    id?: InputMaybe<Scalars['Int']['input']>;
};

/** Customer preferences */
export type CustomerPreferencesInputType = {
    /** Id of the customer */
    customer_id: Scalars['Int']['input'];
    /** True if customer wants to receive messages via email */
    receive_email_channel?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive general messages */
    receive_general_messages?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive messages via mail */
    receive_mail_channel?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive marketing messages */
    receive_marketing_messages?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive messages via mobile phone */
    receive_mobile_phone_channel?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive personal messages */
    receive_personal_messages?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive messages via phone */
    receive_phone_channel?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive service messages */
    receive_service_messages?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive messages via sms */
    receive_sms_channel?: InputMaybe<Scalars['Boolean']['input']>;
    /** True if customer wants to receive messages via whatsapp */
    receive_whatsapp_channel?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Customer preferences. Returns null if no preferences have been set */
export type CustomerPreferencesType = {
    __typename?: 'CustomerPreferencesType';
    /** True if customer wants to receive unread messages reminders via email */
    email_reminder_notification?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive messages via email */
    receive_email_channel?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive general messages */
    receive_general_messages?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive messages via mail */
    receive_mail_channel?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive marketing messages */
    receive_marketing_messages?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive messages via mobile phone */
    receive_mobile_phone_channel?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive personal messages */
    receive_personal_messages?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive messages via phone */
    receive_phone_channel?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive push notifications */
    receive_push_notification_channel?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive service messages */
    receive_service_messages?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive messages via sms */
    receive_sms_channel?: Maybe<Scalars['Boolean']['output']>;
    /** True if customer wants to receive messages via whatsapp */
    receive_whatsapp_channel?: Maybe<Scalars['Boolean']['output']>;
};

/** Customer Quality */
export type CustomerQualityType = {
    __typename?: 'CustomerQualityType';
    /** Total score for the customer data quality */
    total_score?: Maybe<Scalars['Int']['output']>;
    /** widgets on which the score is based on */
    widgets?: Maybe<Array<Maybe<CustomerQualityWidgetType>>>;
};

/** Customer Quality widget */
export type CustomerQualityWidgetType = {
    __typename?: 'CustomerQualityWidgetType';
    /** Field of the widget */
    field?: Maybe<Scalars['String']['output']>;
    /** Score for the customer data quality widget */
    score?: Maybe<Scalars['Int']['output']>;
};

/** A customer */
export type CustomerType = {
    __typename?: 'CustomerType';
    /** Audit trail items of the customer */
    auditTrailItems?: Maybe<Array<Maybe<AuditTrailItemType>>>;
    /** List of linked companies to customer */
    company?: Maybe<Array<Maybe<CompanyType>>>;
    /** The date and time this customer was created (Y-m-d H:i:s) */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** The date and time this customer was created (Y-m-d H:i:s) */
    customer_last_updated?: Maybe<Scalars['String']['output']>;
    /** The date and time this customer was created in ISO format */
    customer_last_updated_iso8601?: Maybe<Scalars['String']['output']>;
    /** Details of a customer */
    data?: Maybe<Array<Maybe<CustomerDataType>>>;
    /** Default location id */
    default_location_id?: Maybe<Scalars['Int']['output']>;
    /** Default specialty id */
    default_specialty_id?: Maybe<Scalars['Int']['output']>;
    /** Default vehicle id */
    default_vehicle_id?: Maybe<Scalars['Int']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    preferences?: Maybe<CustomerPreferencesType>;
    /** File reference to profile picture */
    profilePicture?: Maybe<FileReferenceType>;
    /** The date and time this customer was last edited (Y-m-d H:i:s) */
    updated_at?: Maybe<Scalars['String']['output']>;
    updated_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Vehicles of the customer */
    vehicles?: Maybe<Array<Maybe<VehicleType>>>;
};

export enum DeviceEnum {
    Android = 'android',
    Ios = 'ios',
    Web = 'web',
}

/** Email settings for persisted notifications */
export type EmailSettingsType = {
    __typename?: 'EmailSettingsType';
    /** Location address */
    address?: Maybe<Scalars['String']['output']>;
    /** colour code for the background */
    background_colour?: Maybe<Scalars['String']['output']>;
    /** colour code for the CTA button */
    button_colour?: Maybe<Scalars['String']['output']>;
    /** colour code for the text on the CTA button */
    button_text_colour?: Maybe<Scalars['String']['output']>;
    /** Location email address */
    email_address?: Maybe<Scalars['String']['output']>;
    /** colour code for the background of the footer */
    footer_background_colour?: Maybe<Scalars['String']['output']>;
    /** URL for the footer image */
    footer_image_url?: Maybe<Scalars['String']['output']>;
    /** colour code for the text of the footer */
    footer_text_colour?: Maybe<Scalars['String']['output']>;
    /** URL for the header image */
    header_image_url?: Maybe<Scalars['String']['output']>;
    /** URL for the logo image */
    logo_image_url?: Maybe<Scalars['String']['output']>;
    /** Location phone number */
    phone_number?: Maybe<Scalars['String']['output']>;
    socialMedia?: Maybe<SocialMediaSettingsType>;
    /** colour code for the text colour */
    text_colour?: Maybe<Scalars['String']['output']>;
    /** Location website */
    website?: Maybe<Scalars['String']['output']>;
};

/** Extra field for appointment */
export type ExtraFieldType = {
    __typename?: 'ExtraFieldType';
    /** Length of the field */
    length?: Maybe<Scalars['Int']['output']>;
    /** Name of the field */
    name?: Maybe<Scalars['String']['output']>;
    /** Field is required */
    required?: Maybe<Scalars['Boolean']['output']>;
    /** Type of the field string|integer */
    type?: Maybe<Scalars['String']['output']>;
};

/** Failure indicator */
export type FailureIndicatorType = {
    __typename?: 'FailureIndicatorType';
    /** Brand */
    brand?: Maybe<Scalars['String']['output']>;
    /** Description */
    description?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Image url */
    image_url?: Maybe<Scalars['String']['output']>;
};

/** File Reference */
export type FileReferenceType = {
    __typename?: 'FileReferenceType';
    /** Date the message was created */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Mime type of the file */
    mime_type?: Maybe<Scalars['String']['output']>;
    /** Original filename */
    original_filename?: Maybe<Scalars['String']['output']>;
    /** Url which is valid for one hour */
    signed_url?: Maybe<Scalars['String']['output']>;
};

export type HexonLeadInputType = {
    customerData?: InputMaybe<Array<InputMaybe<CustomerDataInputType>>>;
    leadData?: InputMaybe<Array<InputMaybe<LeadDataInputType>>>;
    lead_provider_name: Scalars['String']['input'];
    lead_type: Scalars['String']['input'];
    location_id: Scalars['Int']['input'];
};

/** Image */
export type ImageType = {
    __typename?: 'ImageType';
    /** Image url */
    url?: Maybe<Scalars['String']['output']>;
};

/** Language */
export type LanguageType = {
    __typename?: 'LanguageType';
    /** Key value */
    key?: Maybe<Scalars['String']['output']>;
    /** Translation value */
    value?: Maybe<Scalars['String']['output']>;
};

/** Data for a lead */
export type LeadDataInputType = {
    /** Key describing which field this data belongs to */
    key: Scalars['String']['input'];
    /** Value of the data */
    value: Scalars['String']['input'];
};

/** LeadData */
export type LeadDataType = {
    __typename?: 'LeadDataType';
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Identifier lead_field_id */
    lead_field_id?: Maybe<Scalars['Int']['output']>;
    /** Identifier lead_id */
    lead_id?: Maybe<Scalars['Int']['output']>;
    /** Identifier organisation_id */
    organisation_id?: Maybe<Scalars['Int']['output']>;
    /** Value */
    value?: Maybe<Scalars['String']['output']>;
};

/** The types of LeadField classifications */
export enum LeadFieldClassificationEnum {
    Date = 'DATE',
    Number = 'NUMBER',
    Text = 'TEXT',
}

export type LeadFieldInputType = {
    classification?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
};

export type LeadFieldType = {
    __typename?: 'LeadFieldType';
    /** Classification of the lead field */
    classification?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Key of the lead field */
    key?: Maybe<Scalars['String']['output']>;
    /** Name of the lead field */
    name?: Maybe<Scalars['String']['output']>;
    /** Applicable for Dropdowns and Radio Buttons. Contains a list of options */
    options?: Maybe<Scalars['String']['output']>;
    /** Order in which to display the LeadFields of a LeadType */
    order?: Maybe<Scalars['Int']['output']>;
    /** Page in where to display the LeadField */
    page?: Maybe<Scalars['Int']['output']>;
    /** Rules for this field */
    rules?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LeadInputType = {
    customerData?: InputMaybe<Array<InputMaybe<CustomerDataInputType>>>;
    customer_id?: InputMaybe<Scalars['Int']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    leadData?: InputMaybe<Array<InputMaybe<LeadDataInputType>>>;
    lead_provider_id?: InputMaybe<Scalars['Int']['input']>;
    lead_type?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
};

export type LeadProviderInputType = {
    id?: InputMaybe<Scalars['Int']['input']>;
    name: Scalars['String']['input'];
};

export type LeadProviderType = {
    __typename?: 'LeadProviderType';
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Name of the lead provider */
    name?: Maybe<Scalars['String']['output']>;
};

export enum LeadSourceEnum {
    App = 'APP',
    Mail = 'MAIL',
    OnLocation = 'ON_LOCATION',
    Phone = 'PHONE',
    Website = 'WEBSITE',
}

/** Lead message */
export type LeadType = {
    __typename?: 'LeadType';
    /** Date the message was created */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Customer who created the lead */
    customer?: Maybe<CustomerType>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    leadData?: Maybe<Array<Maybe<LeadDataType>>>;
    leadProvider?: Maybe<LeadProviderType>;
    leadSourceAppointmentRequest?: Maybe<AppointmentRequestType>;
    leadSourceContactForm?: Maybe<ContactFormType>;
    leadSourceModelAction?: Maybe<ModelActionType>;
    leadSourceOccasionAction?: Maybe<OccasionActionType>;
    /** Lead Type object */
    leadType?: Maybe<LeadTypeType>;
    lead_provider_id?: Maybe<Scalars['String']['output']>;
    /** Lead Type name */
    lead_type?: Maybe<Scalars['String']['output']>;
    /** Text representation of the status */
    state?: Maybe<Scalars['String']['output']>;
};

export enum LeadTypeClassificationEnum {
    AppointmentRequest = 'APPOINTMENT_REQUEST',
    CallbackRequest = 'CALLBACK_REQUEST',
    Complaint = 'COMPLAINT',
    ContactFormSubmission = 'CONTACT_FORM_SUBMISSION',
    Custom = 'CUSTOM',
    CustomAppointmentRequest = 'CUSTOM_APPOINTMENT_REQUEST',
    CustomModelOffer = 'CUSTOM_MODEL_OFFER',
    CustomModelTestdrive = 'CUSTOM_MODEL_TESTDRIVE',
    CustomOccasionOffer = 'CUSTOM_OCCASION_OFFER',
    CustomOccasionTestDrive = 'CUSTOM_OCCASION_TEST_DRIVE',
    CustomOccasionTradein = 'CUSTOM_OCCASION_TRADEIN',
    InformationRequest = 'INFORMATION_REQUEST',
    LeaseRequest = 'LEASE_REQUEST',
    MaintenanceRequest = 'MAINTENANCE_REQUEST',
    ModelOffer = 'MODEL_OFFER',
    ModelTestdrive = 'MODEL_TESTDRIVE',
    OccasionBidding = 'OCCASION_BIDDING',
    OccasionOffer = 'OCCASION_OFFER',
    OccasionPrivateLease = 'OCCASION_PRIVATE_LEASE',
    OccasionTestDrive = 'OCCASION_TEST_DRIVE',
    OccasionTradein = 'OCCASION_TRADEIN',
    OnlineSalesAppointment = 'ONLINE_SALES_APPOINTMENT',
    Other = 'OTHER',
    SearchRequest = 'SEARCH_REQUEST',
    ValueDetermination = 'VALUE_DETERMINATION',
}

export type LeadTypeInputType = {
    /** Classification is used in the backend to differentiate leads with extra features like appointments. Default: CUSTOM */
    classification?: InputMaybe<LeadTypeClassificationEnum>;
    /** Array of LeadField ids */
    fields?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    id?: InputMaybe<Scalars['Int']['input']>;
    /** Name of the LeadType */
    name?: InputMaybe<Scalars['String']['input']>;
    /** States this LeadType can have, like open or closed */
    states?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Lead types */
export type LeadTypeType = {
    __typename?: 'LeadTypeType';
    /** Classification is used in the backend to differentiate leads with extra features like appointments. Default: CUSTOM */
    classification?: Maybe<LeadTypeClassificationEnum>;
    /** Array of CustomerField ids */
    customer_fields?: Maybe<Array<CustomerFieldType>>;
    /** Array of LeadField ids */
    fields?: Maybe<Array<LeadFieldType>>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Name of the LeadType */
    name: Scalars['String']['output'];
    /** Pages */
    pages?: Maybe<Array<Scalars['String']['output']>>;
    /** States this LeadType can have, like open or closed */
    states: Array<Maybe<Scalars['String']['output']>>;
};

/** Location data */
export type LocationDataType = {
    __typename?: 'LocationDataType';
    /** Title of the data */
    title?: Maybe<Scalars['String']['output']>;
    /** Value of the data */
    value?: Maybe<Scalars['String']['output']>;
};

/** A location */
export type LocationType = {
    __typename?: 'LocationType';
    /** City */
    city?: Maybe<Scalars['String']['output']>;
    /** Chamber Of Comerce number */
    coc_number?: Maybe<Scalars['String']['output']>;
    /** Country */
    country?: Maybe<Scalars['String']['output']>;
    /** Email address */
    email?: Maybe<Scalars['String']['output']>;
    /** Extra email addresses */
    email_extra?: Maybe<Array<Maybe<LocationDataType>>>;
    /** Extra emergency phone numbers */
    emergency_phone_extra?: Maybe<Array<Maybe<LocationDataType>>>;
    /** geolocation */
    geolocation?: Maybe<Scalars['String']['output']>;
    /** House number */
    house_number?: Maybe<Scalars['String']['output']>;
    /** House number suffix */
    house_number_suffix?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Name */
    name?: Maybe<Scalars['String']['output']>;
    occasion_key?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** All occasions for this location */
    occasions?: Maybe<Array<Maybe<OccasionType>>>;
    /** Opening hours for this location */
    opening_hours?: Maybe<Array<Maybe<OpeningHourCollectionType>>>;
    /** Organisation */
    organisation?: Maybe<OrganisationType>;
    /** Organisation Id */
    organisation_id?: Maybe<Scalars['Int']['output']>;
    /** Extra phone numbers */
    phone_extra?: Maybe<Array<Maybe<LocationDataType>>>;
    /** Phone number */
    phone_number?: Maybe<Scalars['String']['output']>;
    /** Url of photo */
    photo_url?: Maybe<Scalars['String']['output']>;
    /** Postal code */
    postal_code?: Maybe<Scalars['String']['output']>;
    /** Review settings information for location */
    reviewSettings?: Maybe<Array<Maybe<ReviewSettingsType>>>;
    /** Specialties */
    specialties?: Maybe<Array<Maybe<SpecialtyType>>>;
    /** Street */
    street?: Maybe<Scalars['String']['output']>;
    /** Taxnumber */
    tax_number?: Maybe<Scalars['String']['output']>;
    /** Date the location was updated */
    updated_at?: Maybe<Scalars['String']['output']>;
    /** Website */
    website?: Maybe<Scalars['String']['output']>;
    /** Whatsapp number of the organisation */
    whatsapp_number?: Maybe<Scalars['String']['output']>;
};

/** A location */
export type LocationTypeOpening_HoursArgs = {
    end?: InputMaybe<Scalars['String']['input']>;
    start?: InputMaybe<Scalars['String']['input']>;
};

/** A location */
export type LocationTypeSpecialtiesArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

/** Device (app installation) for a management user */
export type ManagementDeviceType = {
    __typename?: 'ManagementDeviceType';
    /** firebase_token */
    firebase_token?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** user_id */
    user_id?: Maybe<Scalars['Int']['output']>;
};

/** App menu item */
export type MenuItemType = {
    __typename?: 'MenuItemType';
    /** Name of menuitem */
    name?: Maybe<Scalars['String']['output']>;
    /** URL of menuitem */
    url?: Maybe<Scalars['String']['output']>;
};

/** An model action which can be an offer or testdrive request */
export type ModelActionType = {
    __typename?: 'ModelActionType';
    /** Customer who made the request */
    customer?: Maybe<CustomerType>;
    /** customer_id */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** json encoded string with information of the occasion action */
    extra?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    model?: Maybe<ModelType>;
    /** ID of the occasion */
    model_id?: Maybe<Scalars['Int']['output']>;
    /** Remarks of the customer */
    remarks?: Maybe<Scalars['String']['output']>;
    /** Status of the occasion action */
    status?: Maybe<Scalars['String']['output']>;
    /** Type of occasion action (offer or tradein) */
    type?: Maybe<Scalars['String']['output']>;
};

/** Model */
export type ModelType = {
    __typename?: 'ModelType';
    /** Big image for model */
    big_image_url?: Maybe<Scalars['String']['output']>;
    /** Brand the model belongs to */
    brand?: Maybe<Scalars['String']['output']>;
    /** Brochure */
    brochure_url?: Maybe<Scalars['String']['output']>;
    /** Description */
    description?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Image for model */
    image_url?: Maybe<Scalars['String']['output']>;
    /** Images */
    images?: Maybe<Array<Maybe<ImageType>>>;
    /** Name of the model */
    name?: Maybe<Scalars['String']['output']>;
    /** Pricelist */
    pricelist_url?: Maybe<Scalars['String']['output']>;
    /** Specifications */
    specifications_url?: Maybe<Scalars['String']['output']>;
    /** Types */
    types?: Maybe<Array<Maybe<ModelType>>>;
    /** Video for model */
    video?: Maybe<OccasionVideoType>;
};

/** ModelType */
export type ModelTypeType = {
    __typename?: 'ModelTypeType';
    /** Description */
    description?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Image for model */
    image_url?: Maybe<Scalars['String']['output']>;
    /** Name of the model */
    name?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
    __typename?: 'Mutation';
    /** Add vehicle to customer */
    AddVehicle?: Maybe<VehicleType>;
    ChatRead?: Maybe<Scalars['Boolean']['output']>;
    /** Set or update profile picture */
    ProfilePicture?: Maybe<CustomerType>;
    /** Register a new customer device */
    RegisterCustomerDevice?: Maybe<CustomerDeviceType>;
    /** Remove vehicle from customer */
    RemoveVehicle?: Maybe<Scalars['Boolean']['output']>;
    /** Send a chat message */
    SendChatMessage?: Maybe<ChatType>;
    /** Send a chat message */
    SendOffer?: Maybe<Scalars['Boolean']['output']>;
    /** Set customer data */
    SetCustomerData?: Maybe<CustomerDataType>;
    /** Set default location for customer */
    SetDefaultLocation?: Maybe<Scalars['Int']['output']>;
    /** Set default specialty for customer */
    SetDefaultSpecialty?: Maybe<Scalars['Int']['output']>;
    /** Set default vehicle for customer */
    SetDefaultVehicle?: Maybe<Scalars['Int']['output']>;
    /** Set all customer data fields for customer */
    SyncCustomerData?: Maybe<CustomerType>;
    /** Update the date when the customer has last been seen */
    UpdateDateLastSeen?: Maybe<Scalars['Boolean']['output']>;
    /** Set customer preferences */
    UpdatePreferences?: Maybe<CustomerPreferencesType>;
    /** Update vehicle information */
    UpdateVehicle?: Maybe<VehicleType>;
    /** Creates a Lead */
    createLead?: Maybe<LeadType>;
    /** Deletes the account of the customer */
    deleteAccount?: Maybe<Scalars['Boolean']['output']>;
    markMessagesRead?: Maybe<Scalars['Boolean']['output']>;
    /** Update if the customer has completed the onboarding */
    onboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
    readNotification?: Maybe<Scalars['Boolean']['output']>;
    /** update a Lead */
    updateLead?: Maybe<LeadType>;
};

export type MutationAddVehicleArgs = {
    vehicle_identifier?: InputMaybe<Scalars['String']['input']>;
};

export type MutationProfilePictureArgs = {
    profile_picture?: InputMaybe<Scalars['Upload']['input']>;
};

export type MutationRegisterCustomerDeviceArgs = {
    device_type?: InputMaybe<DeviceEnum>;
    firebase_token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationRemoveVehicleArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSendChatMessageArgs = {
    file?: InputMaybe<Scalars['Upload']['input']>;
    message?: InputMaybe<Scalars['String']['input']>;
    persisted_notification_id?: InputMaybe<Scalars['Int']['input']>;
    url?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSendOfferArgs = {
    occasion_id?: InputMaybe<Scalars['Int']['input']>;
    remarks?: InputMaybe<Scalars['String']['input']>;
    trade_identifier?: InputMaybe<Scalars['String']['input']>;
    trade_mileage?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetCustomerDataArgs = {
    key?: InputMaybe<Scalars['String']['input']>;
    value?: InputMaybe<Scalars['String']['input']>;
};

export type MutationSetDefaultLocationArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSetDefaultSpecialtyArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSetDefaultVehicleArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationSyncCustomerDataArgs = {
    customerData?: InputMaybe<Array<InputMaybe<CustomerDataInputType>>>;
};

export type MutationUpdatePreferencesArgs = {
    customerPreferences?: InputMaybe<CustomerPreferencesInputType>;
};

export type MutationUpdateVehicleArgs = {
    vehicle?: InputMaybe<VehicleInputType>;
};

export type MutationCreateLeadArgs = {
    state?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
};

export type MutationReadNotificationArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type MutationUpdateLeadArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
};

/** News */
export type NewsItemType = {
    __typename?: 'NewsItemType';
    /** Content */
    content?: Maybe<Scalars['String']['output']>;
    /** Date the newsitem was created */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Image url */
    image?: Maybe<Scalars['String']['output']>;
    /** Preface */
    preface?: Maybe<Scalars['String']['output']>;
    /** Newsitem should be published on app */
    publish_app?: Maybe<Scalars['Boolean']['output']>;
    /** Newsitem should be published on this date */
    publish_date?: Maybe<Scalars['String']['output']>;
    /** Newsitem should be published on web */
    publish_web?: Maybe<Scalars['Boolean']['output']>;
    /** SEO URL */
    seo_url?: Maybe<Scalars['String']['output']>;
    /** Small description */
    small_description?: Maybe<Scalars['String']['output']>;
    /** Thumbnail url */
    thumbnail?: Maybe<Scalars['String']['output']>;
    /** Title */
    title?: Maybe<Scalars['String']['output']>;
    /** Author */
    user?: Maybe<UserType>;
};

/** Notification */
export type NotificationType = {
    __typename?: 'NotificationType';
    /** CTA action to be displayed */
    action?: Maybe<Scalars['String']['output']>;
    /** CTA text to be displayed */
    action_text?: Maybe<Scalars['String']['output']>;
    /** CTA URL to link to */
    action_url?: Maybe<Scalars['String']['output']>;
    /** Created at */
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Email settings linked to the persisted notification */
    emailSettings?: Maybe<EmailSettingsType>;
    /** From email address */
    from_email?: Maybe<Scalars['String']['output']>;
    /** icon selected for notification */
    icon?: Maybe<Scalars['String']['output']>;
    /** colour code for the icon background */
    icon_colour_background?: Maybe<Scalars['String']['output']>;
    /** Identifier */
    id?: Maybe<Scalars['Int']['output']>;
    /** Message */
    message?: Maybe<Scalars['String']['output']>;
    /** Title in the message */
    message_title?: Maybe<Scalars['String']['output']>;
    /** colour code for the message title */
    message_title_colour?: Maybe<Scalars['String']['output']>;
    /** Read */
    read?: Maybe<Scalars['Boolean']['output']>;
    /** Title */
    title?: Maybe<Scalars['String']['output']>;
    /** Type of the notification (general or vehicle related) */
    type?: Maybe<Scalars['String']['output']>;
    /** Updated at */
    updated_at?: Maybe<Scalars['String']['output']>;
    updated_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** ID of the vehicle linked to the message */
    vehicle_id?: Maybe<Scalars['Int']['output']>;
};

/** An occasion action which can be an offer or trade in request */
export type OccasionActionType = {
    __typename?: 'OccasionActionType';
    /** Customer who made the request */
    customer?: Maybe<CustomerType>;
    /** customer_id */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** json encoded string with information of the occasion action */
    extra?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Occasion on which the action occured */
    occasion?: Maybe<OccasionType>;
    /** ID of the occasion */
    occasion_id?: Maybe<Scalars['Int']['output']>;
    /** Remarks of the customer */
    remarks?: Maybe<Scalars['String']['output']>;
    /** Status of the occasion action */
    status?: Maybe<Scalars['String']['output']>;
    /** Type of occasion action (offer or tradein) */
    type?: Maybe<Scalars['String']['output']>;
    /** vehicle_Type of occasion (personal or commercial) */
    vehicle_type?: Maybe<Scalars['String']['output']>;
};

/** Brand used to filter occasions */
export type OccasionBrandType = {
    __typename?: 'OccasionBrandType';
    models?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    name?: Maybe<Scalars['String']['output']>;
};

/** Financing attributes of an occasion */
export type OccasionFinancingType = {
    __typename?: 'OccasionFinancingType';
    /** Minimum lease price for this occasion based on 60 month term */
    lease_price?: Maybe<Scalars['Int']['output']>;
    /** Url used for calculating financing for this occasion */
    url?: Maybe<Scalars['String']['output']>;
};

export type OccasionOptionType = {
    __typename?: 'OccasionOptionType';
    category?: Maybe<Scalars['String']['output']>;
    option?: Maybe<Scalars['String']['output']>;
};

/** An occasion */
export type OccasionType = {
    __typename?: 'OccasionType';
    acceleration?: Maybe<Scalars['Int']['output']>;
    additional_fields?: Maybe<Scalars['String']['output']>;
    apk_date?: Maybe<Scalars['String']['output']>;
    apk_delivery?: Maybe<Scalars['String']['output']>;
    autosoft360?: Maybe<Scalars['String']['output']>;
    autosoft_iframe_url?: Maybe<Scalars['String']['output']>;
    bodywork?: Maybe<Scalars['String']['output']>;
    bovag_warranty?: Maybe<Scalars['Boolean']['output']>;
    bovag_warranty_months?: Maybe<Scalars['Int']['output']>;
    /** BPM used for the in and ex price calculations */
    bpm?: Maybe<Scalars['Int']['output']>;
    brand?: Maybe<Scalars['String']['output']>;
    build_month?: Maybe<Scalars['String']['output']>;
    build_year?: Maybe<Scalars['String']['output']>;
    co2_emissions?: Maybe<Scalars['Int']['output']>;
    color?: Maybe<Scalars['String']['output']>;
    created_at?: Maybe<Scalars['String']['output']>;
    created_at_iso8601?: Maybe<Scalars['String']['output']>;
    /** Custom warranty filled in by organisation */
    customer_warranty?: Maybe<Scalars['String']['output']>;
    cylinder_capacity?: Maybe<Scalars['String']['output']>;
    cylinder_capacity_type?: Maybe<Scalars['String']['output']>;
    cylinders?: Maybe<Scalars['String']['output']>;
    date_first_admission?: Maybe<Scalars['String']['output']>;
    date_first_issue?: Maybe<Scalars['String']['output']>;
    dealer_maintained?: Maybe<Scalars['Boolean']['output']>;
    delivery_costs?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    description_characteristics?: Maybe<Scalars['String']['output']>;
    description_text?: Maybe<Scalars['String']['output']>;
    doors?: Maybe<Scalars['String']['output']>;
    emission_class?: Maybe<Scalars['String']['output']>;
    energy_label?: Maybe<Scalars['String']['output']>;
    financing?: Maybe<OccasionFinancingType>;
    first_owner?: Maybe<Scalars['Boolean']['output']>;
    fuel?: Maybe<Scalars['String']['output']>;
    fuel_consumption_average?: Maybe<Scalars['Float']['output']>;
    fuel_consumption_city?: Maybe<Scalars['Float']['output']>;
    fuel_consumption_highway?: Maybe<Scalars['Float']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    imported?: Maybe<Scalars['Boolean']['output']>;
    interior?: Maybe<Scalars['String']['output']>;
    interior_color?: Maybe<Scalars['String']['output']>;
    location_id?: Maybe<Scalars['Int']['output']>;
    maintenance_booklets?: Maybe<Scalars['Boolean']['output']>;
    max_towing_weight?: Maybe<Scalars['Int']['output']>;
    media_url?: Maybe<Scalars['String']['output']>;
    mileage?: Maybe<Scalars['String']['output']>;
    model?: Maybe<Scalars['String']['output']>;
    model_code?: Maybe<Scalars['String']['output']>;
    model_range_from?: Maybe<Scalars['String']['output']>;
    model_range_till?: Maybe<Scalars['String']['output']>;
    nap?: Maybe<Scalars['Boolean']['output']>;
    new_price?: Maybe<Scalars['Int']['output']>;
    number_of_gears?: Maybe<Scalars['Int']['output']>;
    number_of_owners?: Maybe<Scalars['Int']['output']>;
    number_of_seats?: Maybe<Scalars['Int']['output']>;
    numberplate?: Maybe<Scalars['String']['output']>;
    one_hundred_percent_maintained?: Maybe<Scalars['Boolean']['output']>;
    options?: Maybe<Array<Maybe<OccasionOptionType>>>;
    /** Iframe URL for Photomotion 360 photo */
    photomotion?: Maybe<Scalars['String']['output']>;
    pictures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    power?: Maybe<Scalars['String']['output']>;
    power_type?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Int']['output']>;
    raw_price_text?: Maybe<Scalars['String']['output']>;
    rdw_odometer_report_url?: Maybe<Scalars['String']['output']>;
    road_tax_max?: Maybe<Scalars['Int']['output']>;
    road_tax_min?: Maybe<Scalars['Int']['output']>;
    road_tax_per_quarter?: Maybe<Scalars['Int']['output']>;
    /** Iframe URL for Spincar 360 photo */
    spincar?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    supplier_customer_id?: Maybe<Scalars['String']['output']>;
    supplier_occasion_id?: Maybe<Scalars['String']['output']>;
    tax?: Maybe<Scalars['String']['output']>;
    top_speed?: Maybe<Scalars['Int']['output']>;
    torque?: Maybe<Scalars['Int']['output']>;
    transmission?: Maybe<Scalars['String']['output']>;
    turn_circle?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updated_at?: Maybe<Scalars['String']['output']>;
    updated_at_iso8601?: Maybe<Scalars['String']['output']>;
    videos?: Maybe<Array<Maybe<OccasionVideoType>>>;
    vivition?: Maybe<Scalars['String']['output']>;
    warranty?: Maybe<Scalars['String']['output']>;
    weight?: Maybe<Scalars['String']['output']>;
    weight_type?: Maybe<Scalars['String']['output']>;
};

export type OccasionVideoType = {
    __typename?: 'OccasionVideoType';
    code?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

/** Opening Hours */
export type OpeningHourCollectionType = {
    __typename?: 'OpeningHourCollectionType';
    /** End date/time of break time */
    break_times?: Maybe<Array<Maybe<BreakTimeType>>>;
    /** End date/time of opening hour */
    opening_hours?: Maybe<Array<Maybe<OpeningHourType>>>;
    /** Opening hour type */
    type?: Maybe<Scalars['String']['output']>;
};

/** Opening Hour */
export type OpeningHourType = {
    __typename?: 'OpeningHourType';
    /** End date/time of opening hour */
    end?: Maybe<Scalars['String']['output']>;
    /** Start date/time of opening hour */
    start?: Maybe<Scalars['String']['output']>;
};

/** A organisation */
export type OrganisationType = {
    __typename?: 'OrganisationType';
    /** if this is true than a vehicle may be manually enriched */
    allow_manual_enrichment?: Maybe<Scalars['Boolean']['output']>;
    /** Url to play store app */
    android_link?: Maybe<Scalars['String']['output']>;
    /** Email */
    email?: Maybe<Scalars['String']['output']>;
    /** Color for the button in the email */
    email_button_color?: Maybe<Scalars['String']['output']>;
    /** public URL of the email footer image */
    email_footer_image?: Maybe<Scalars['String']['output']>;
    /** public URL of the email header image */
    email_header_image?: Maybe<Scalars['String']['output']>;
    /** Text color for the button in the email */
    email_text_color?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Url to app store app  */
    ios_link?: Maybe<Scalars['String']['output']>;
    /** Locations */
    locations?: Maybe<Array<Maybe<LocationType>>>;
    /** Logo */
    logo?: Maybe<Scalars['String']['output']>;
    /** Name */
    name?: Maybe<Scalars['String']['output']>;
    /** Displays what occasion provider needs to be used */
    occasion_provider?: Maybe<Scalars['String']['output']>;
    /** Phone number */
    phone_number?: Maybe<Scalars['String']['output']>;
    /** Displays the timezone set on organisation */
    timezone?: Maybe<Scalars['String']['output']>;
    /** If this is true, the organisation uses V2 of Edlink */
    uses_v2?: Maybe<Scalars['Boolean']['output']>;
    /** Whatsapp number of the organisation */
    whatsapp_number?: Maybe<Scalars['String']['output']>;
};

/** Page info */
export type PageInfoType = {
    __typename?: 'PageInfoType';
    /** Number of items in page */
    count?: Maybe<Scalars['Int']['output']>;
    /** Number of pages based on limit */
    numberOfPages?: Maybe<Scalars['Int']['output']>;
};

export type Query = {
    __typename?: 'Query';
    /** Appointment requests of customer */
    appointments?: Maybe<Array<Maybe<AppointmentRequestType>>>;
    /** Chat for current user */
    chat?: Maybe<ChatType>;
    /** Available data fields for customers in an organisation */
    customerFields?: Maybe<Array<Maybe<CustomerFieldType>>>;
    /** Get notification based on ID */
    getNotification?: Maybe<NotificationType>;
    /** Logged in customer account information */
    me?: Maybe<CustomerAccountType>;
    /** Notifications sent to customer */
    notifications?: Maybe<Array<Maybe<NotificationType>>>;
};

export type QueryAppointmentsArgs = {
    appointment_date_from?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['Int']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    page?: InputMaybe<Scalars['Int']['input']>;
    status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetNotificationArgs = {
    id?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryNotificationsArgs = {
    read?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Planner activity */
export type ReplacementVehicleType = {
    __typename?: 'ReplacementVehicleType';
    /** Identifier */
    id?: Maybe<Scalars['String']['output']>;
    /** Display name */
    name?: Maybe<Scalars['String']['output']>;
};

/** Review information of the organisation */
export type ReviewContentType = {
    __typename?: 'ReviewContentType';
    /** Answer given by the reviewer */
    answer?: Maybe<Scalars['String']['output']>;
    /** Question given in the review */
    question?: Maybe<Scalars['String']['output']>;
    /** Question group it belongs to */
    question_group?: Maybe<Scalars['String']['output']>;
};

/** List with reviews of the company */
export type ReviewListType = {
    __typename?: 'ReviewListType';
    /** City of the reviewer */
    city?: Maybe<Scalars['String']['output']>;
    /** Name of the reviewer */
    name?: Maybe<Scalars['String']['output']>;
    /** Rating given by the reviewer */
    rating?: Maybe<Scalars['Int']['output']>;
    /** Comment on the review by the organisation */
    reviewComment?: Maybe<Scalars['String']['output']>;
    /** List of information given in the review */
    reviewContent?: Maybe<Array<Maybe<ReviewContentType>>>;
    /** Date of the review in Y-m-d H:i format */
    reviewDate?: Maybe<Scalars['String']['output']>;
};

/** Review settings information */
export type ReviewSettingsType = {
    __typename?: 'ReviewSettingsType';
    /** Name of review company settings are for */
    review_company?: Maybe<Scalars['String']['output']>;
};

/** Review information of the organisation */
export type ReviewType = {
    __typename?: 'ReviewType';
    /** Average rating of the organisation over the past 12 months */
    average12MonthsRating?: Maybe<Scalars['Float']['output']>;
    /** Average rating of the organisation */
    averageRating?: Maybe<Scalars['Float']['output']>;
    /** Pagecount for pagination */
    numberOfPages?: Maybe<Scalars['Int']['output']>;
    /** Number of reviews made about the company */
    numberOfReviews?: Maybe<Scalars['Int']['output']>;
    /** Number of reviews made about the organisation over the past 12 months */
    numberOfReviews12Months?: Maybe<Scalars['Float']['output']>;
    /** Percentage of reviewers that recommend the company */
    percentageRecommended?: Maybe<Scalars['Int']['output']>;
    /** List of reviews */
    reviewList?: Maybe<Array<Maybe<ReviewListType>>>;
    /** URL to view all reviews on the source */
    reviewUrl?: Maybe<Scalars['String']['output']>;
    /** Source of the reviews */
    source?: Maybe<Scalars['String']['output']>;
    /** URL to fill in a review */
    surveyUrl?: Maybe<Scalars['String']['output']>;
};

/** Signature of the user and organisation */
export type SignatureType = {
    __typename?: 'SignatureType';
    imageUrl?: Maybe<Scalars['String']['output']>;
    signature?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

/** Social media settings for email settings */
export type SocialMediaSettingsType = {
    __typename?: 'SocialMediaSettingsType';
    /** URL for the header image */
    facebook?: Maybe<Scalars['String']['output']>;
    /** URL for the footer image */
    instagram?: Maybe<Scalars['String']['output']>;
    /** URL for the logo image */
    linkedin?: Maybe<Scalars['String']['output']>;
    /** colour code for the background */
    snapchat?: Maybe<Scalars['String']['output']>;
    /** colour code for the text colour */
    tiktok?: Maybe<Scalars['String']['output']>;
    /** colour code for the CTA button */
    twitter?: Maybe<Scalars['String']['output']>;
    /** colour code for the text on the CTA button */
    youtube?: Maybe<Scalars['String']['output']>;
};

/** Location Specialty */
export type SpecialtyType = {
    __typename?: 'SpecialtyType';
    /** Planner Activities for this location */
    activities?: Maybe<Array<Maybe<ActivityType>>>;
    /** Planner Availabilties for this location */
    availabilities?: Maybe<Array<Maybe<AvailabilityType>>>;
    /** Times available for planning */
    available_times?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Extra fields to send with appointment */
    extra_fields?: Maybe<Array<Maybe<ExtraFieldType>>>;
    /** Identifier */
    id?: Maybe<Scalars['String']['output']>;
    /** Specialty image */
    image_url?: Maybe<Scalars['String']['output']>;
    /** Display name */
    name?: Maybe<Scalars['String']['output']>;
    /** Planner Replacement Vehicles for this location */
    replacement_vehicles?: Maybe<Array<Maybe<ReplacementVehicleType>>>;
};

/** Location Specialty */
export type SpecialtyTypeAvailabilitiesArgs = {
    activity?: InputMaybe<Scalars['String']['input']>;
    end?: InputMaybe<Scalars['String']['input']>;
    extra_jobs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    replacement_vehicle?: InputMaybe<Scalars['String']['input']>;
    start?: InputMaybe<Scalars['String']['input']>;
};

/** Location Specialty */
export type SpecialtyTypeAvailable_TimesArgs = {
    activity: Scalars['String']['input'];
    date: Scalars['String']['input'];
    extra_jobs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A user */
export type UserType = {
    __typename?: 'UserType';
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Name */
    name?: Maybe<Scalars['String']['output']>;
    /** Authorization Token */
    token?: Maybe<Scalars['String']['output']>;
};

/** Vehicle identifier */
export type VehicleIdentifierType = {
    __typename?: 'VehicleIdentifierType';
    /** Type of identifier (license_plate|vin_number) */
    type?: Maybe<Scalars['String']['output']>;
    /** Identifier value */
    value?: Maybe<Scalars['String']['output']>;
};

/** Vehicle image */
export type VehicleImageType = {
    __typename?: 'VehicleImageType';
    /** Image type (front|rear|interior|thumb_front|thumb_rear|thumb_interior) */
    type?: Maybe<Scalars['String']['output']>;
    /** Url to the image */
    url?: Maybe<Scalars['String']['output']>;
};

/** A vehicle */
export type VehicleInputType = {
    /** Next maintenance date for airco formatted in Y-m-d */
    airco_next_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Next maintenance date for break fluid formatted in Y-m-d */
    brake_fluid_next_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Vehicle brand */
    brand?: InputMaybe<Scalars['String']['input']>;
    /** Vehicle build year */
    buildyear?: InputMaybe<Scalars['Int']['input']>;
    /** Vehicle color */
    color?: InputMaybe<Scalars['String']['input']>;
    /** Last maintenance date for distribution belt in Y-m-d */
    distribution_belt_last_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Next maintenance date for distribution formatted in Y-m-d */
    distribution_belt_next_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Vehicle fuel type */
    fuel_type?: InputMaybe<Scalars['String']['input']>;
    /** Id */
    id?: InputMaybe<Scalars['Int']['input']>;
    /** Vehicle inspection expiration date / APK / MOT */
    inspection_expiration_date?: InputMaybe<Scalars['String']['input']>;
    /** Last maintenance date for vehicle formatted in Y-m-d */
    latest_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Vehicle is leased */
    lease?: InputMaybe<Scalars['Boolean']['input']>;
    /** Vehicle mileage */
    mileage?: InputMaybe<Scalars['Int']['input']>;
    /** Vehicle model */
    model?: InputMaybe<Scalars['String']['input']>;
    /** Next maintenance date for vehicle formatted in Y-m-d */
    next_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Next maintenance date for alarm formatted in Y-m-d */
    rcm_next_maintenance_date?: InputMaybe<Scalars['String']['input']>;
    /** Tires of the vehicle (default: SUMMER_AND_WINTER) */
    tires?: InputMaybe<VehicleTyreTypesEnum>;
    /** Vehicle type */
    type?: InputMaybe<Scalars['String']['input']>;
    /** Vehicle vin number */
    vin_number?: InputMaybe<Scalars['String']['input']>;
};

/** Vehicle mileage history */
export type VehicleMileageHistoryType = {
    __typename?: 'VehicleMileageHistoryType';
    /** Date of the mileage */
    date?: Maybe<Scalars['String']['output']>;
    /** ID of the model */
    id?: Maybe<Scalars['Int']['output']>;
    /** Indication where the data is from */
    is_from_maintenance?: Maybe<Scalars['Boolean']['output']>;
    /** Mileage in Km */
    mileage?: Maybe<Scalars['Int']['output']>;
};

/** Vehicle details */
export type VehicleType = {
    __typename?: 'VehicleType';
    /** Next airco maintenance date (Y-m-d) */
    airco_next_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Ascription date (Y-m-d) */
    ascription_date?: Maybe<Scalars['String']['output']>;
    /** Brake fluid next maintenance date (Y-m-d) */
    brake_fluid_next_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Brand */
    brand?: Maybe<Scalars['String']['output']>;
    /** Build year */
    buildyear?: Maybe<Scalars['Int']['output']>;
    /** Color */
    color?: Maybe<Scalars['String']['output']>;
    /** Id of the customer */
    customer_id?: Maybe<Scalars['Int']['output']>;
    /** Description */
    description?: Maybe<Scalars['String']['output']>;
    /** Last maintenance date for distribution belt (Y-m-d) */
    distribution_belt_last_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Next maintenance date for distribution belt (Y-m-d) */
    distribution_belt_next_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Fuel type */
    fuel_type?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** Identifiers */
    identifiers?: Maybe<Array<Maybe<VehicleIdentifierType>>>;
    /** Images of this vehicle model */
    images?: Maybe<Array<Maybe<VehicleImageType>>>;
    /** Inspection expiration date (Y-m-d) */
    inspection_expiration_date?: Maybe<Scalars['String']['output']>;
    /** Inspection expiration date (Y-m-d) */
    latest_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Lease */
    lease?: Maybe<Scalars['Boolean']['output']>;
    /** Mileage */
    mileage?: Maybe<Scalars['Int']['output']>;
    /** Mileage history of this vehicle model */
    mileageHistory?: Maybe<Array<Maybe<VehicleMileageHistoryType>>>;
    /** Model */
    model?: Maybe<Scalars['String']['output']>;
    /** Next maintenance date for vehicle (Y-m-d) */
    next_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Next alarm maintenance date (Y-m-d) */
    rcm_maintenance_date?: Maybe<Scalars['String']['output']>;
    /** Tires */
    tires?: Maybe<Scalars['String']['output']>;
    /** Type */
    type?: Maybe<Scalars['String']['output']>;
};

/** The types of vehicle tyres */
export enum VehicleTyreTypesEnum {
    AllSeason = 'ALL_SEASON',
    SummerAndWinter = 'SUMMER_AND_WINTER',
    SummerOnly = 'SUMMER_ONLY',
    Unknown = 'UNKNOWN',
    WinterOnly = 'WINTER_ONLY',
}

/** Webuilder images used for brands and affiliates */
export type WebbuilderImageType = {
    __typename?: 'WebbuilderImageType';
    /** Image ID */
    id?: Maybe<Scalars['Int']['output']>;
    /** Image url */
    image_url?: Maybe<Scalars['String']['output']>;
    /** Brand/affiliate name */
    name?: Maybe<Scalars['String']['output']>;
};

export type VehicleFragmentFragment = {
    __typename: 'VehicleType';
    id?: number | null;
    brand?: string | null;
    model?: string | null;
    buildyear?: number | null;
    lease?: boolean | null;
    mileage?: number | null;
    tires?: string | null;
    color?: string | null;
    fuel_type?: string | null;
    inspection_expiration_date?: string | null;
    identifiers?: Array<{
        __typename: 'VehicleIdentifierType';
        type?: string | null;
        value?: string | null;
    } | null> | null;
    images?: Array<{__typename: 'VehicleImageType'; type?: string | null; url?: string | null} | null> | null;
};

export type CustomerPreferencesFragmentFragment = {
    __typename: 'CustomerPreferencesType';
    receive_marketing_messages?: boolean | null;
    receive_service_messages?: boolean | null;
    receive_personal_messages?: boolean | null;
    receive_general_messages?: boolean | null;
    receive_email_channel?: boolean | null;
    receive_phone_channel?: boolean | null;
    receive_whatsapp_channel?: boolean | null;
    receive_sms_channel?: boolean | null;
    receive_mobile_phone_channel?: boolean | null;
    receive_mail_channel?: boolean | null;
};

export type CustomerFragmentFragment = {
    __typename: 'CustomerType';
    id?: number | null;
    default_location_id?: number | null;
    default_specialty_id?: number | null;
    data?: Array<{
        __typename: 'CustomerDataType';
        name?: string | null;
        key?: string | null;
        value?: string | null;
    } | null> | null;
    profilePicture?: {__typename: 'FileReferenceType'; signed_url?: string | null} | null;
    preferences?: {
        __typename: 'CustomerPreferencesType';
        receive_marketing_messages?: boolean | null;
        receive_service_messages?: boolean | null;
        receive_personal_messages?: boolean | null;
        receive_general_messages?: boolean | null;
        receive_email_channel?: boolean | null;
        receive_phone_channel?: boolean | null;
        receive_whatsapp_channel?: boolean | null;
        receive_sms_channel?: boolean | null;
        receive_mobile_phone_channel?: boolean | null;
        receive_mail_channel?: boolean | null;
    } | null;
    vehicles?: Array<{
        __typename: 'VehicleType';
        id?: number | null;
        brand?: string | null;
        model?: string | null;
        buildyear?: number | null;
        lease?: boolean | null;
        mileage?: number | null;
        tires?: string | null;
        color?: string | null;
        fuel_type?: string | null;
        inspection_expiration_date?: string | null;
        mileageHistory?: Array<{
            __typename: 'VehicleMileageHistoryType';
            mileage?: number | null;
            date?: string | null;
            is_from_maintenance?: boolean | null;
        } | null> | null;
        identifiers?: Array<{
            __typename: 'VehicleIdentifierType';
            type?: string | null;
            value?: string | null;
        } | null> | null;
        images?: Array<{__typename: 'VehicleImageType'; type?: string | null; url?: string | null} | null> | null;
    } | null> | null;
};

export type GetMeQueryVariables = Exact<{[key: string]: never}>;

export type GetMeQuery = {
    __typename?: 'Query';
    me?: {
        __typename: 'CustomerAccountType';
        id?: number | null;
        email?: string | null;
        onboarding_completed?: boolean | null;
        show_onboarding?: boolean | null;
        customer?: {
            __typename: 'CustomerType';
            id?: number | null;
            default_location_id?: number | null;
            default_specialty_id?: number | null;
            data?: Array<{
                __typename: 'CustomerDataType';
                name?: string | null;
                key?: string | null;
                value?: string | null;
            } | null> | null;
            profilePicture?: {__typename: 'FileReferenceType'; signed_url?: string | null} | null;
            preferences?: {
                __typename: 'CustomerPreferencesType';
                receive_marketing_messages?: boolean | null;
                receive_service_messages?: boolean | null;
                receive_personal_messages?: boolean | null;
                receive_general_messages?: boolean | null;
                receive_email_channel?: boolean | null;
                receive_phone_channel?: boolean | null;
                receive_whatsapp_channel?: boolean | null;
                receive_sms_channel?: boolean | null;
                receive_mobile_phone_channel?: boolean | null;
                receive_mail_channel?: boolean | null;
            } | null;
            vehicles?: Array<{
                __typename: 'VehicleType';
                id?: number | null;
                brand?: string | null;
                model?: string | null;
                buildyear?: number | null;
                lease?: boolean | null;
                mileage?: number | null;
                tires?: string | null;
                color?: string | null;
                fuel_type?: string | null;
                inspection_expiration_date?: string | null;
                mileageHistory?: Array<{
                    __typename: 'VehicleMileageHistoryType';
                    mileage?: number | null;
                    date?: string | null;
                    is_from_maintenance?: boolean | null;
                } | null> | null;
                identifiers?: Array<{
                    __typename: 'VehicleIdentifierType';
                    type?: string | null;
                    value?: string | null;
                } | null> | null;
                images?: Array<{
                    __typename: 'VehicleImageType';
                    type?: string | null;
                    url?: string | null;
                } | null> | null;
            } | null> | null;
        } | null;
    } | null;
    customerFields?: Array<{
        __typename: 'CustomerFieldType';
        key?: string | null;
        name?: string | null;
        default?: boolean | null;
        classification?: string | null;
        show_public?: boolean | null;
        edit_public?: boolean | null;
    } | null> | null;
};

export type NotificationFragmentFragment = {
    __typename: 'NotificationType';
    id?: number | null;
    title?: string | null;
    message?: string | null;
    action?: string | null;
    read?: boolean | null;
    created_at?: string | null;
    created_at_iso8601?: string | null;
    updated_at?: string | null;
    updated_at_iso8601?: string | null;
    type?: string | null;
    vehicle_id?: number | null;
    icon?: string | null;
    icon_colour_background?: string | null;
    message_title?: string | null;
    message_title_colour?: string | null;
    emailSettings?: {
        __typename?: 'EmailSettingsType';
        header_image_url?: string | null;
        footer_image_url?: string | null;
        logo_image_url?: string | null;
        background_colour?: string | null;
        text_colour?: string | null;
        button_colour?: string | null;
        button_text_colour?: string | null;
        footer_background_colour?: string | null;
        footer_text_colour?: string | null;
        phone_number?: string | null;
        email_address?: string | null;
        website?: string | null;
        address?: string | null;
        socialMedia?: {
            __typename?: 'SocialMediaSettingsType';
            facebook?: string | null;
            instagram?: string | null;
            linkedin?: string | null;
            snapchat?: string | null;
            tiktok?: string | null;
            twitter?: string | null;
            youtube?: string | null;
        } | null;
    } | null;
};

export type ChatMessageFragmentFragment = {
    __typename: 'ChatMessageType';
    id?: number | null;
    action?: string | null;
    message?: string | null;
    read?: boolean | null;
    created_at?: string | null;
    created_at_iso8601?: string | null;
    file?: {
        __typename: 'FileReferenceType';
        signed_url?: string | null;
        original_filename?: string | null;
        mime_type?: string | null;
    } | null;
    user?: {__typename: 'UserType'; id?: number | null; name?: string | null; token?: string | null} | null;
    persistedNotification?: {
        __typename: 'NotificationType';
        id?: number | null;
        title?: string | null;
        message?: string | null;
        action?: string | null;
        read?: boolean | null;
        created_at?: string | null;
        created_at_iso8601?: string | null;
        updated_at?: string | null;
        updated_at_iso8601?: string | null;
        type?: string | null;
        vehicle_id?: number | null;
        icon?: string | null;
        icon_colour_background?: string | null;
        message_title?: string | null;
        message_title_colour?: string | null;
        emailSettings?: {
            __typename?: 'EmailSettingsType';
            header_image_url?: string | null;
            footer_image_url?: string | null;
            logo_image_url?: string | null;
            background_colour?: string | null;
            text_colour?: string | null;
            button_colour?: string | null;
            button_text_colour?: string | null;
            footer_background_colour?: string | null;
            footer_text_colour?: string | null;
            phone_number?: string | null;
            email_address?: string | null;
            website?: string | null;
            address?: string | null;
            socialMedia?: {
                __typename?: 'SocialMediaSettingsType';
                facebook?: string | null;
                instagram?: string | null;
                linkedin?: string | null;
                snapchat?: string | null;
                tiktok?: string | null;
                twitter?: string | null;
                youtube?: string | null;
            } | null;
        } | null;
    } | null;
};

export type ChatFragmentFragment = {
    __typename: 'ChatType';
    id?: number | null;
    uuid?: string | null;
    messages?: Array<{
        __typename: 'ChatMessageType';
        id?: number | null;
        action?: string | null;
        message?: string | null;
        read?: boolean | null;
        created_at?: string | null;
        created_at_iso8601?: string | null;
        file?: {
            __typename: 'FileReferenceType';
            signed_url?: string | null;
            original_filename?: string | null;
            mime_type?: string | null;
        } | null;
        user?: {__typename: 'UserType'; id?: number | null; name?: string | null; token?: string | null} | null;
        persistedNotification?: {
            __typename: 'NotificationType';
            id?: number | null;
            title?: string | null;
            message?: string | null;
            action?: string | null;
            read?: boolean | null;
            created_at?: string | null;
            created_at_iso8601?: string | null;
            updated_at?: string | null;
            updated_at_iso8601?: string | null;
            type?: string | null;
            vehicle_id?: number | null;
            icon?: string | null;
            icon_colour_background?: string | null;
            message_title?: string | null;
            message_title_colour?: string | null;
            emailSettings?: {
                __typename?: 'EmailSettingsType';
                header_image_url?: string | null;
                footer_image_url?: string | null;
                logo_image_url?: string | null;
                background_colour?: string | null;
                text_colour?: string | null;
                button_colour?: string | null;
                button_text_colour?: string | null;
                footer_background_colour?: string | null;
                footer_text_colour?: string | null;
                phone_number?: string | null;
                email_address?: string | null;
                website?: string | null;
                address?: string | null;
                socialMedia?: {
                    __typename?: 'SocialMediaSettingsType';
                    facebook?: string | null;
                    instagram?: string | null;
                    linkedin?: string | null;
                    snapchat?: string | null;
                    tiktok?: string | null;
                    twitter?: string | null;
                    youtube?: string | null;
                } | null;
            } | null;
        } | null;
    } | null> | null;
};

export type GetChatQueryVariables = Exact<{
    last_message_id?: InputMaybe<Scalars['Int']['input']>;
    read?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetChatQuery = {
    __typename?: 'Query';
    chat?: {
        __typename: 'ChatType';
        id?: number | null;
        uuid?: string | null;
        messages?: Array<{
            __typename: 'ChatMessageType';
            id?: number | null;
            action?: string | null;
            message?: string | null;
            read?: boolean | null;
            created_at?: string | null;
            created_at_iso8601?: string | null;
            file?: {
                __typename: 'FileReferenceType';
                signed_url?: string | null;
                original_filename?: string | null;
                mime_type?: string | null;
            } | null;
            user?: {__typename: 'UserType'; id?: number | null; name?: string | null; token?: string | null} | null;
            persistedNotification?: {
                __typename: 'NotificationType';
                id?: number | null;
                title?: string | null;
                message?: string | null;
                action?: string | null;
                read?: boolean | null;
                created_at?: string | null;
                created_at_iso8601?: string | null;
                updated_at?: string | null;
                updated_at_iso8601?: string | null;
                type?: string | null;
                vehicle_id?: number | null;
                icon?: string | null;
                icon_colour_background?: string | null;
                message_title?: string | null;
                message_title_colour?: string | null;
                emailSettings?: {
                    __typename?: 'EmailSettingsType';
                    header_image_url?: string | null;
                    footer_image_url?: string | null;
                    logo_image_url?: string | null;
                    background_colour?: string | null;
                    text_colour?: string | null;
                    button_colour?: string | null;
                    button_text_colour?: string | null;
                    footer_background_colour?: string | null;
                    footer_text_colour?: string | null;
                    phone_number?: string | null;
                    email_address?: string | null;
                    website?: string | null;
                    address?: string | null;
                    socialMedia?: {
                        __typename?: 'SocialMediaSettingsType';
                        facebook?: string | null;
                        instagram?: string | null;
                        linkedin?: string | null;
                        snapchat?: string | null;
                        tiktok?: string | null;
                        twitter?: string | null;
                        youtube?: string | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
};

export type GetNotificationsQueryVariables = Exact<{[key: string]: never}>;

export type GetNotificationsQuery = {
    __typename?: 'Query';
    notifications?: Array<{
        __typename: 'NotificationType';
        id?: number | null;
        title?: string | null;
        message?: string | null;
        action?: string | null;
        read?: boolean | null;
        created_at?: string | null;
        created_at_iso8601?: string | null;
        updated_at?: string | null;
        updated_at_iso8601?: string | null;
        type?: string | null;
        vehicle_id?: number | null;
        icon?: string | null;
        icon_colour_background?: string | null;
        message_title?: string | null;
        message_title_colour?: string | null;
        emailSettings?: {
            __typename?: 'EmailSettingsType';
            header_image_url?: string | null;
            footer_image_url?: string | null;
            logo_image_url?: string | null;
            background_colour?: string | null;
            text_colour?: string | null;
            button_colour?: string | null;
            button_text_colour?: string | null;
            footer_background_colour?: string | null;
            footer_text_colour?: string | null;
            phone_number?: string | null;
            email_address?: string | null;
            website?: string | null;
            address?: string | null;
            socialMedia?: {
                __typename?: 'SocialMediaSettingsType';
                facebook?: string | null;
                instagram?: string | null;
                linkedin?: string | null;
                snapchat?: string | null;
                tiktok?: string | null;
                twitter?: string | null;
                youtube?: string | null;
            } | null;
        } | null;
    } | null> | null;
};

export type MarkNotificationReadMutationVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type MarkNotificationReadMutation = {__typename?: 'Mutation'; readNotification?: boolean | null};

export type MarkMessagesReadMutationVariables = Exact<{[key: string]: never}>;

export type MarkMessagesReadMutation = {__typename?: 'Mutation'; markMessagesRead?: boolean | null};

export type SendChatMessageMutationVariables = Exact<{
    message: Scalars['String']['input'];
    url?: InputMaybe<Scalars['String']['input']>;
    persisted_notification_id?: InputMaybe<Scalars['Int']['input']>;
    last_message_id?: InputMaybe<Scalars['Int']['input']>;
    read?: InputMaybe<Scalars['Boolean']['input']>;
    file?: InputMaybe<Scalars['Upload']['input']>;
}>;

export type SendChatMessageMutation = {
    __typename?: 'Mutation';
    SendChatMessage?: {
        __typename: 'ChatType';
        id?: number | null;
        uuid?: string | null;
        messages?: Array<{
            __typename: 'ChatMessageType';
            id?: number | null;
            action?: string | null;
            message?: string | null;
            read?: boolean | null;
            created_at?: string | null;
            created_at_iso8601?: string | null;
            file?: {
                __typename: 'FileReferenceType';
                signed_url?: string | null;
                original_filename?: string | null;
                mime_type?: string | null;
            } | null;
            user?: {__typename: 'UserType'; id?: number | null; name?: string | null; token?: string | null} | null;
            persistedNotification?: {
                __typename: 'NotificationType';
                id?: number | null;
                title?: string | null;
                message?: string | null;
                action?: string | null;
                read?: boolean | null;
                created_at?: string | null;
                created_at_iso8601?: string | null;
                updated_at?: string | null;
                updated_at_iso8601?: string | null;
                type?: string | null;
                vehicle_id?: number | null;
                icon?: string | null;
                icon_colour_background?: string | null;
                message_title?: string | null;
                message_title_colour?: string | null;
                emailSettings?: {
                    __typename?: 'EmailSettingsType';
                    header_image_url?: string | null;
                    footer_image_url?: string | null;
                    logo_image_url?: string | null;
                    background_colour?: string | null;
                    text_colour?: string | null;
                    button_colour?: string | null;
                    button_text_colour?: string | null;
                    footer_background_colour?: string | null;
                    footer_text_colour?: string | null;
                    phone_number?: string | null;
                    email_address?: string | null;
                    website?: string | null;
                    address?: string | null;
                    socialMedia?: {
                        __typename?: 'SocialMediaSettingsType';
                        facebook?: string | null;
                        instagram?: string | null;
                        linkedin?: string | null;
                        snapchat?: string | null;
                        tiktok?: string | null;
                        twitter?: string | null;
                        youtube?: string | null;
                    } | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
};

export type SyncCustomerDataMutationVariables = Exact<{
    data: Array<InputMaybe<CustomerDataInputType>> | InputMaybe<CustomerDataInputType>;
}>;

export type SyncCustomerDataMutation = {
    __typename?: 'Mutation';
    customer?: {
        __typename: 'CustomerType';
        id?: number | null;
        default_location_id?: number | null;
        default_specialty_id?: number | null;
        data?: Array<{
            __typename: 'CustomerDataType';
            name?: string | null;
            key?: string | null;
            value?: string | null;
        } | null> | null;
        profilePicture?: {__typename: 'FileReferenceType'; signed_url?: string | null} | null;
        preferences?: {
            __typename: 'CustomerPreferencesType';
            receive_marketing_messages?: boolean | null;
            receive_service_messages?: boolean | null;
            receive_personal_messages?: boolean | null;
            receive_general_messages?: boolean | null;
            receive_email_channel?: boolean | null;
            receive_phone_channel?: boolean | null;
            receive_whatsapp_channel?: boolean | null;
            receive_sms_channel?: boolean | null;
            receive_mobile_phone_channel?: boolean | null;
            receive_mail_channel?: boolean | null;
        } | null;
        vehicles?: Array<{
            __typename: 'VehicleType';
            id?: number | null;
            brand?: string | null;
            model?: string | null;
            buildyear?: number | null;
            lease?: boolean | null;
            mileage?: number | null;
            tires?: string | null;
            color?: string | null;
            fuel_type?: string | null;
            inspection_expiration_date?: string | null;
            mileageHistory?: Array<{
                __typename: 'VehicleMileageHistoryType';
                mileage?: number | null;
                date?: string | null;
                is_from_maintenance?: boolean | null;
            } | null> | null;
            identifiers?: Array<{
                __typename: 'VehicleIdentifierType';
                type?: string | null;
                value?: string | null;
            } | null> | null;
            images?: Array<{__typename: 'VehicleImageType'; type?: string | null; url?: string | null} | null> | null;
        } | null> | null;
    } | null;
};

export type UpdatePreferencesMutationVariables = Exact<{
    data?: InputMaybe<CustomerPreferencesInputType>;
}>;

export type UpdatePreferencesMutation = {
    __typename?: 'Mutation';
    customer?: {
        __typename: 'CustomerPreferencesType';
        receive_marketing_messages?: boolean | null;
        receive_service_messages?: boolean | null;
        receive_personal_messages?: boolean | null;
        receive_general_messages?: boolean | null;
        receive_email_channel?: boolean | null;
        receive_phone_channel?: boolean | null;
        receive_whatsapp_channel?: boolean | null;
        receive_sms_channel?: boolean | null;
        receive_mobile_phone_channel?: boolean | null;
        receive_mail_channel?: boolean | null;
    } | null;
};

export type SetDefaultLocationMutationVariables = Exact<{
    id: Scalars['Int']['input'];
}>;

export type SetDefaultLocationMutation = {__typename?: 'Mutation'; SetDefaultLocation?: number | null};

export type ProfilePictureMutationVariables = Exact<{
    profilePicture: Scalars['Upload']['input'];
}>;

export type ProfilePictureMutation = {
    __typename?: 'Mutation';
    ProfilePicture?: {
        __typename: 'CustomerType';
        profilePicture?: {__typename: 'FileReferenceType'; signed_url?: string | null} | null;
    } | null;
};

export type RegisterCustomerDeviceMutationVariables = Exact<{
    firebase_token?: InputMaybe<Scalars['String']['input']>;
    device_type?: InputMaybe<DeviceEnum>;
}>;

export type RegisterCustomerDeviceMutation = {
    __typename?: 'Mutation';
    RegisterCustomerDevice?: {__typename: 'CustomerDeviceType'; id?: number | null} | null;
};

export type GetRegisteredDevicesQueryVariables = Exact<{[key: string]: never}>;

export type GetRegisteredDevicesQuery = {
    __typename?: 'Query';
    me?: {
        __typename: 'CustomerAccountType';
        customerDevices?: Array<{__typename: 'CustomerDeviceType'; firebase_token?: string | null} | null> | null;
    } | null;
};

export type DeleteAccountMutationVariables = Exact<{[key: string]: never}>;

export type DeleteAccountMutation = {__typename?: 'Mutation'; deleteAccount?: boolean | null};

export type OnboardingCompletedMutationVariables = Exact<{[key: string]: never}>;

export type OnboardingCompletedMutation = {__typename?: 'Mutation'; onboardingCompleted?: boolean | null};

export type AddVehicleMutationVariables = Exact<{
    license_plate?: InputMaybe<Scalars['String']['input']>;
}>;

export type AddVehicleMutation = {
    __typename?: 'Mutation';
    AddVehicle?: {
        __typename: 'VehicleType';
        id?: number | null;
        brand?: string | null;
        model?: string | null;
        buildyear?: number | null;
        lease?: boolean | null;
        mileage?: number | null;
        tires?: string | null;
        color?: string | null;
        fuel_type?: string | null;
        inspection_expiration_date?: string | null;
        identifiers?: Array<{
            __typename: 'VehicleIdentifierType';
            type?: string | null;
            value?: string | null;
        } | null> | null;
        images?: Array<{__typename: 'VehicleImageType'; type?: string | null; url?: string | null} | null> | null;
    } | null;
};

export type EditVehicleMutationVariables = Exact<{
    vehicle: VehicleInputType;
}>;

export type EditVehicleMutation = {
    __typename?: 'Mutation';
    UpdateVehicle?: {
        __typename: 'VehicleType';
        id?: number | null;
        brand?: string | null;
        model?: string | null;
        buildyear?: number | null;
        lease?: boolean | null;
        mileage?: number | null;
        tires?: string | null;
        color?: string | null;
        fuel_type?: string | null;
        inspection_expiration_date?: string | null;
        identifiers?: Array<{
            __typename: 'VehicleIdentifierType';
            type?: string | null;
            value?: string | null;
        } | null> | null;
        images?: Array<{__typename: 'VehicleImageType'; type?: string | null; url?: string | null} | null> | null;
    } | null;
};

export type DeleteVehicleMutationVariables = Exact<{
    id?: InputMaybe<Scalars['Int']['input']>;
}>;

export type DeleteVehicleMutation = {__typename?: 'Mutation'; RemoveVehicle?: boolean | null};

export const CustomerPreferencesFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerPreferencesFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerPreferencesType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_marketing_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_service_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_personal_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_general_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_email_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_whatsapp_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_sms_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mobile_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mail_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomerPreferencesFragmentFragment, unknown>;
export const VehicleFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'VehicleFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'model'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'identifiers'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'buildyear'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'lease'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'tires'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'color'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'fuel_type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'inspection_expiration_date'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'images'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<VehicleFragmentFragment, unknown>;
export const CustomerFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'default_location_id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'default_specialty_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'data'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'profilePicture'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preferences'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerPreferencesFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'vehicles'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'VehicleFragment'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'mileageHistory'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'is_from_maintenance'}},
                                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                        ],
                                    },
                                },
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerPreferencesFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerPreferencesType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_marketing_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_service_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_personal_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_general_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_email_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_whatsapp_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_sms_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mobile_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mail_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'VehicleFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'model'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'identifiers'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'buildyear'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'lease'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'tires'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'color'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'fuel_type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'inspection_expiration_date'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'images'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<CustomerFragmentFragment, unknown>;
export const NotificationFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'NotificationFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'NotificationType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'vehicle_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'emailSettings'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'header_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'logo_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'phone_number'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email_address'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'socialMedia'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'facebook'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'instagram'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'linkedin'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'snapchat'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'tiktok'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'twitter'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'youtube'}},
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'icon'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'icon_colour_background'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title_colour'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<NotificationFragmentFragment, unknown>;
export const ChatMessageFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatMessageFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatMessageType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'file'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'original_filename'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'mime_type'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'user'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'token'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'persistedNotification'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'NotificationFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'NotificationFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'NotificationType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'vehicle_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'emailSettings'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'header_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'logo_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'phone_number'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email_address'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'socialMedia'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'facebook'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'instagram'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'linkedin'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'snapchat'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'tiktok'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'twitter'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'youtube'}},
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'icon'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'icon_colour_background'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title_colour'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<ChatMessageFragmentFragment, unknown>;
export const ChatFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'messages'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'read'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'read'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'last_message_id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'last_message_id'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChatMessageFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'NotificationFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'NotificationType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'vehicle_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'emailSettings'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'header_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'logo_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'phone_number'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email_address'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'socialMedia'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'facebook'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'instagram'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'linkedin'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'snapchat'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'tiktok'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'twitter'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'youtube'}},
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'icon'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'icon_colour_background'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title_colour'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatMessageFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatMessageType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'file'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'original_filename'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'mime_type'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'user'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'token'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'persistedNotification'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'NotificationFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<ChatFragmentFragment, unknown>;
export const GetMeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {kind: 'Name', value: 'getMe'},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'me'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'customer'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerFragment'}},
                                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                        ],
                                    },
                                },
                                {kind: 'Field', name: {kind: 'Name', value: 'onboarding_completed'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'show_onboarding'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'customerFields'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'default'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'classification'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'show_public'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'edit_public'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerPreferencesFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerPreferencesType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_marketing_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_service_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_personal_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_general_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_email_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_whatsapp_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_sms_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mobile_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mail_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'VehicleFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'model'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'identifiers'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'buildyear'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'lease'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'tires'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'color'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'fuel_type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'inspection_expiration_date'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'images'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'default_location_id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'default_specialty_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'data'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'profilePicture'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preferences'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerPreferencesFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'vehicles'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'VehicleFragment'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'mileageHistory'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'is_from_maintenance'}},
                                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                        ],
                                    },
                                },
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetMeQuery, GetMeQueryVariables>;
export const GetChatDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {kind: 'Name', value: 'getChat'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'last_message_id'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'read'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'chat'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChatFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'NotificationFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'NotificationType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'vehicle_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'emailSettings'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'header_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'logo_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'phone_number'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email_address'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'socialMedia'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'facebook'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'instagram'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'linkedin'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'snapchat'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'tiktok'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'twitter'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'youtube'}},
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'icon'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'icon_colour_background'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title_colour'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatMessageFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatMessageType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'file'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'original_filename'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'mime_type'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'user'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'token'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'persistedNotification'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'NotificationFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'messages'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'read'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'read'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'last_message_id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'last_message_id'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChatMessageFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetChatQuery, GetChatQueryVariables>;
export const GetNotificationsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {kind: 'Name', value: 'getNotifications'},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'notifications'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'NotificationFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'NotificationFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'NotificationType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'vehicle_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'emailSettings'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'header_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'logo_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'phone_number'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email_address'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'socialMedia'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'facebook'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'instagram'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'linkedin'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'snapchat'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'tiktok'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'twitter'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'youtube'}},
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'icon'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'icon_colour_background'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title_colour'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const MarkNotificationReadDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'MarkNotificationRead'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'readNotification'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<MarkNotificationReadMutation, MarkNotificationReadMutationVariables>;
export const MarkMessagesReadDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'markMessagesRead'},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{kind: 'Field', name: {kind: 'Name', value: 'markMessagesRead'}}],
            },
        },
    ],
} as unknown as DocumentNode<MarkMessagesReadMutation, MarkMessagesReadMutationVariables>;
export const SendChatMessageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'sendChatMessage'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'message'}},
                    type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'persisted_notification_id'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'last_message_id'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'read'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Boolean'}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'file'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Upload'}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'SendChatMessage'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'message'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'message'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'url'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'url'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'persisted_notification_id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'persisted_notification_id'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'file'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'file'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChatFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'NotificationFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'NotificationType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'updated_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'vehicle_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'emailSettings'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'header_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'logo_image_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'button_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_background_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'footer_text_colour'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'phone_number'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'email_address'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'website'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'address'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'socialMedia'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'facebook'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'instagram'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'linkedin'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'snapchat'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'tiktok'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'twitter'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'youtube'}},
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'icon'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'icon_colour_background'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message_title_colour'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatMessageFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatMessageType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'action'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'message'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'file'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'original_filename'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'mime_type'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'user'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'token'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'persistedNotification'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'NotificationFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'read'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'created_at_iso8601'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'ChatFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'ChatType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'uuid'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'messages'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'read'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'read'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'last_message_id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'last_message_id'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'ChatMessageFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<SendChatMessageMutation, SendChatMessageMutationVariables>;
export const SyncCustomerDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'SyncCustomerData'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'data'}},
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerDataInputType'}},
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'customer'},
                        name: {kind: 'Name', value: 'SyncCustomerData'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'customerData'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'data'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerPreferencesFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerPreferencesType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_marketing_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_service_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_personal_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_general_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_email_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_whatsapp_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_sms_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mobile_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mail_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'VehicleFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'model'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'identifiers'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'buildyear'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'lease'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'tires'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'color'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'fuel_type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'inspection_expiration_date'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'images'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'default_location_id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'default_specialty_id'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'data'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'name'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'key'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'profilePicture'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'preferences'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerPreferencesFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'vehicles'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'VehicleFragment'}},
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'mileageHistory'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'date'}},
                                            {kind: 'Field', name: {kind: 'Name', value: 'is_from_maintenance'}},
                                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                        ],
                                    },
                                },
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<SyncCustomerDataMutation, SyncCustomerDataMutationVariables>;
export const UpdatePreferencesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'UpdatePreferences'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'data'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerPreferencesInputType'}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: {kind: 'Name', value: 'customer'},
                        name: {kind: 'Name', value: 'UpdatePreferences'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'customerPreferences'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'data'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'CustomerPreferencesFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'CustomerPreferencesFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'CustomerPreferencesType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_marketing_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_service_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_personal_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_general_messages'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_email_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_whatsapp_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_sms_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mobile_phone_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'receive_mail_channel'}},
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<UpdatePreferencesMutation, UpdatePreferencesMutationVariables>;
export const SetDefaultLocationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'setDefaultLocation'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'SetDefaultLocation'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<SetDefaultLocationMutation, SetDefaultLocationMutationVariables>;
export const ProfilePictureDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'profilePicture'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'profilePicture'}},
                    type: {kind: 'NonNullType', type: {kind: 'NamedType', name: {kind: 'Name', value: 'Upload'}}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'ProfilePicture'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'profile_picture'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'profilePicture'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'profilePicture'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'signed_url'}},
                                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                        ],
                                    },
                                },
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<ProfilePictureMutation, ProfilePictureMutationVariables>;
export const RegisterCustomerDeviceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'registerCustomerDevice'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'firebase_token'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
                },
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'device_type'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'DeviceEnum'}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'RegisterCustomerDevice'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'firebase_token'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'firebase_token'}},
                            },
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'device_type'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'device_type'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<RegisterCustomerDeviceMutation, RegisterCustomerDeviceMutationVariables>;
export const GetRegisteredDevicesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {kind: 'Name', value: 'getRegisteredDevices'},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'me'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: {kind: 'Name', value: 'customerDevices'},
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {kind: 'Field', name: {kind: 'Name', value: 'firebase_token'}},
                                            {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                                        ],
                                    },
                                },
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<GetRegisteredDevicesQuery, GetRegisteredDevicesQueryVariables>;
export const DeleteAccountDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'deleteAccount'},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{kind: 'Field', name: {kind: 'Name', value: 'deleteAccount'}}],
            },
        },
    ],
} as unknown as DocumentNode<DeleteAccountMutation, DeleteAccountMutationVariables>;
export const OnboardingCompletedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'onboardingCompleted'},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [{kind: 'Field', name: {kind: 'Name', value: 'onboardingCompleted'}}],
            },
        },
    ],
} as unknown as DocumentNode<OnboardingCompletedMutation, OnboardingCompletedMutationVariables>;
export const AddVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'addVehicle'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'license_plate'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'String'}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'AddVehicle'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'vehicle_identifier'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'license_plate'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'VehicleFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'VehicleFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'model'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'identifiers'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'buildyear'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'lease'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'tires'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'color'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'fuel_type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'inspection_expiration_date'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'images'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<AddVehicleMutation, AddVehicleMutationVariables>;
export const EditVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'EditVehicle'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'vehicle'}},
                    type: {
                        kind: 'NonNullType',
                        type: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleInputType'}},
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'UpdateVehicle'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'vehicle'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'vehicle'}},
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'FragmentSpread', name: {kind: 'Name', value: 'VehicleFragment'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                ],
            },
        },
        {
            kind: 'FragmentDefinition',
            name: {kind: 'Name', value: 'VehicleFragment'},
            typeCondition: {kind: 'NamedType', name: {kind: 'Name', value: 'VehicleType'}},
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {kind: 'Field', name: {kind: 'Name', value: 'id'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'brand'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'model'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'identifiers'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'value'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: 'buildyear'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'lease'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'mileage'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'tires'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'color'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'fuel_type'}},
                    {kind: 'Field', name: {kind: 'Name', value: 'inspection_expiration_date'}},
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'images'},
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {kind: 'Field', name: {kind: 'Name', value: 'type'}},
                                {kind: 'Field', name: {kind: 'Name', value: 'url'}},
                                {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                            ],
                        },
                    },
                    {kind: 'Field', name: {kind: 'Name', value: '__typename'}},
                ],
            },
        },
    ],
} as unknown as DocumentNode<EditVehicleMutation, EditVehicleMutationVariables>;
export const DeleteVehicleDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: {kind: 'Name', value: 'deleteVehicle'},
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                    type: {kind: 'NamedType', name: {kind: 'Name', value: 'Int'}},
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: {kind: 'Name', value: 'RemoveVehicle'},
                        arguments: [
                            {
                                kind: 'Argument',
                                name: {kind: 'Name', value: 'id'},
                                value: {kind: 'Variable', name: {kind: 'Name', value: 'id'}},
                            },
                        ],
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<DeleteVehicleMutation, DeleteVehicleMutationVariables>;
